// import API from "@/api";

import cities from "@/assets/geo/cities.json"
import constituencies from "@/assets/geo/constituencies.json"
import states from "@/assets/geo/states.json"

import * as types from "./mutation-types"

const namespaced = true;

const initialState = {
  constituencies: [],
  states: [],
  cities: []
};

const mutations = {
  [types.PUT_CITIES](state, cities) {
    state.cities = cities
  },
  [types.PUT_CONSTITUENCIES](state, constituencies) {
    state.constituencies = constituencies
  },
  [types.PUT_STATES](state, states) {
    state.states = states
  }
};

const actions = {
  getCities: ({ commit }) => {
    // return API.get("cities.json").then(data => {
    //   commit(types.PUT_CITIES, JSON.stringify(data))
    // })
    commit(types.PUT_CITIES, JSON.stringify(cities))
  },
  getConstituencies: ({ commit }) => {
    // return API.get("constituencies.json").then(data => {
    //   commit(types.PUT_CONSTITUENCIES, JSON.stringify(data))
    // })
    commit(types.PUT_CONSTITUENCIES, JSON.stringify(constituencies))
  },
  getStates: ({ commit }) => {
    // return API.get("states.json").then(data => {
    //   commit(types.PUT_COUNTRIES, JSON.stringify(data))
    // })
    commit(types.PUT_STATES, JSON.stringify(states))
  }
};

const getters = {
  cities(state) {
    return state.cities
  },
  constituencies(state) {
    return state.constituencies
  },
  states(state) {
    return state.states
  }
};

export default {
  namespaced,
  state: initialState,
  mutations,
  actions,
  getters
};
